import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { PlasmaWaveAnimation } from '../blasts/PlasmaWave';

registerCollisionAnimation('PLASMA_BLOB', (ctx, e, config, progress) => {
  PlasmaWaveAnimation(ctx, e as any, config, progress);
});
